import { useIntl } from 'react-intl';

import { EvidencePlatformSidebarAppID } from '@verantos-dev/core-enums';

/**
 * VEP-specific hook to get section names for the sidebar.
 * This is VEP-specific and should not be in shared libraries.
 */
export const useVepSectionName = () => {
  const { formatMessage } = useIntl();

  return (appId: EvidencePlatformSidebarAppID) => {
    switch (appId) {
      case EvidencePlatformSidebarAppID.projects:
      case EvidencePlatformSidebarAppID.conceptGroups:
        return formatMessage({ id: 'sidebar.sectionTitle.projects' });
      case EvidencePlatformSidebarAppID.users:
      case EvidencePlatformSidebarAppID.organizations:
        return formatMessage({ id: 'sidebar.sectionTitle.sysAdmin' });
      case EvidencePlatformSidebarAppID.extractionAccuracy:
        return formatMessage({ id: 'sidebar.sectionTitle.extractionAccuracy' });
      default:
        return '';
    }
  };
};
